import { Link } from '@reach/router';
import styled from 'styled-components';

import {
  scale100,
  scale180,
  xdlColorDisabledStrong,
  xdlColorTextSecondary,
  xdlColorText,
  scale060,
} from '@xing-com/tokens';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${scale180};
  color: ${xdlColorTextSecondary};
  text-align: center;
`;

export const ArrowContainer = styled(Link)<{
  $isDisabled: boolean;
}>`
  display: flex;
  align-self: stretch;
  width: 24px;
  height: 100%;
  color: ${xdlColorText};

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    pointer-events: none;
    color: ${xdlColorDisabledStrong};
  `}
`;

export const PaginationLabelsContainer = styled.div`
  display: flex;
  margin: 0 ${scale100};
`;

export const PaginationLabel = styled.div`
  padding: 0 ${scale060};
  color: ${xdlColorText};
`;

export const PaginationLink = styled(Link)<{
  $isActive: boolean;
}>`
  position: relative;
  z-index: 1;
  padding: 0 ${scale060};
  color: ${({ $isActive }) => ($isActive ? '#fff' : xdlColorText)};

  &:hover,
  &:focus {
    text-decoration: none;
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    &:before {
      content: '';
      width: 24px;
      height: 24px;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      background-color: ${xdlColorText};
      border-radius: 12px;
    }
  `};
`;
